import React from "react"
import { Navigate } from "react-router-dom"
import PageContainer from "src/components/page/PageContainer"
import TabbedPageContainer from "src/components/page/TabbedPageContainer"
import { GatedCommunitiesTab } from "./GatedCommunitiesTab"
import { useResponsive } from "src/utils/useResponsive"

/** Page showing only the Gated Communities tab (for gated community managers who are not org admins). */
const GatedCommunitiesPage = () => {
  const { isMobile } = useResponsive()
  if (isMobile) {
    return <Navigate to="" replace />
  }
  return (
    <PageContainer>
      <TabbedPageContainer
        defaultTabId="gated-communities"
        tabs={[
          {
            id: "gated-communities",
            label: "Knowledge Bases",
            content: <GatedCommunitiesTab />
          }
        ]}
      />
    </PageContainer>
  )
}

export default GatedCommunitiesPage
